import { UploadExcelThemeModeConfig } from './types';

const light: UploadExcelThemeModeConfig = {
  uploadExcel: {
    uploadTempBGColor: 'linear-gradient(to top, #33adff44, #FFFFFFFF)',
    normalButtonBGColor: 'none',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
